import "core-js/modules/es.array.push.js";
import { Sketch } from '@ckpack/vue-color';
export default {
  components: {
    'sketch-picker': Sketch
  },
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      colors: 'rgba(0,0,0,0.51)',
      colorvalue: 'rgba(0,0,0,0.51)',
      showSketch: false
    };
  },
  created() {},
  methods: {
    okHandle() {
      let rgbaval = [];
      Object.keys(this.colors.rgba).forEach(child => {
        rgbaval.push(this.colors.rgba[child]);
      });
      this.colorvalue = `rgba(${rgbaval.join(',')})`;
      this.showSketch = false;
    }
  }
};